// import React from "react";
// import RoleHead from "./TableHead/RoleHead";
// import RoleBody from "./TableBody/RoleBody";

// const RoleTable = ({
//   permissionsAccessControl,
//   roles,
//   handleDelete,
//   handleResetPass,
//   status,
// }) => {
//   return (
//     <div className="row" style={{ marginTop: "10px" }}>
//       <div className="col-12">
//         <div className="card">
//           <div className="card__body">
//             <div className="table-wrapper">
//               <table style={{ overflow: "hidden" }}>
//                 <RoleHead
//                   permissionsAccessControl={permissionsAccessControl}
//                   status={status}
//                 />
//                 <RoleBody
//                   roles={roles}
//                   handleDelete={handleDelete}
//                   handleResetPass={handleResetPass}
//                   status={status}
//                 />
//               </table>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

import ReusableDataTable from "src/components/table/ReusableDataTable";
import GetRoleTableColumns from "./ColumnDefinition/RoleColumn/GetRoleTableColumns";
import { mapRoleToDataTable as mapData } from "./Helper";

const RoleTable = ({ data, handleDelete, status }) => {
  const columns = GetRoleTableColumns({ handleDelete, status });

  return (
    <ReusableDataTable columns={columns} data={mapData(data)} maxHeight={500} />
  );
};

export default RoleTable;
